const translations = {
    ru: {
        affiliate: "Аффилиат",
        firstName: "Имя",
        lastName: "Фамилия",
        email: "Email",
        password: "Пароль",
        desk: "Деск",
        manager: "Менеджеры",
        saleStatus: "Дефолтный сэйл статус",
        isBlocked: "Заблокирован",
    },
    en: {
        affiliate: "Affiliate",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        password: "Password",
        desk: "Desk",
        manager: "Managers",
        saleStatus: "Default sale status",
        isBlocked: "Blocked",
    },
};

export const getAffiliateFields = (langSelected) => {
    const t = translations[langSelected] || translations.ru;
    return [
        {key: "affiliate", label: t.affiliate, type: "input", required: true},
        {key: "first_name", label: t.firstName, type: "input", required: true},
        {key: "last_name", label: t.lastName, type: "input", required: true},
        {key: "email", label: t.email, type: "input", required: true},
        {key: "password", label: t.password, type: "input", required: true},
        {key: "admin_ids", label: t.manager, type: "multiDropdown", required: false},
        {key: "desk_id", label: t.desk, type: "dropdown", required: false},
        {key: "sale_status", label: t.saleStatus, type: "dropdown", required: false},
        {key: "is_blocked", label: t.isBlocked, type: "checkbox", required: false},
    ];
};
